import React, {FC} from 'react';
import styles from './Footer.module.css';

import {Grid} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

import Logo from "../../resources/Footer/Footer_Logo.png";
import GooglePlay from "../../resources/Footer/Google.png";
import AppStore from "../../resources/Footer/Apple.png";
import YoutubeLogo from "../../resources/Footer/youtube.svg";
import InstagramLogo from "../../resources/Footer/instagram.svg";
import FaceBookLogo from "../../resources/Footer/facebook.svg";
import NIHILogo from "../../resources/Footer/NIHI-footer.svg";
import UniServicesLogo from "../../resources/Footer/uniservices-white.png";
import UoALogo from "../../resources/Footer/UoA Logo.svg";
import ChatIcon from "../../resources/Footer/mobile_chat_icon.png";
import {useAuth} from "../../services/AuthProvider";

interface FooterProps {}

interface LinkItem {
  to: string;
  text: string;
}

interface FooterLinksProps {
  links: LinkItem[];
}

interface FooterPanelProps {
  title: string;
  links: LinkItem[];
  lg?: number; // optional md prop for specifying the grid width
}

const footerPanels: FooterPanelProps[] = [
  {
    title: 'General',
    links: [
      { to: 'https://www.sparx.org.nz/', text: 'Home' },
      { to: 'https://www.sparx.org.nz/the-game', text: 'The Game' },
      { to: 'https://www.sparx.org.nz/about-us', text: 'About Us' },
      { to: '/check_my_mood', text: 'Mood Quiz' },
      { to: 'https://www.sparx.org.nz/contact', text: 'Contact' },
    ],
    lg: 2
  },
  {
    title: 'Resources',
    links: [
      { to: 'https://www.sparx.org.nz/friends-and-whanau', text: 'Friends & Whānau' },
      { to: 'https://www.sparx.org.nz/teachers-and-healthprofessionals', text: 'Teachers & Health Professionals' },
      { to: 'https://www.sparx.org.nz/publications', text: 'Publications' },
      { to: 'https://www.sparx.org.nz/support', text: 'FAQs' },
    ],
    lg: 3
  }
];

const FooterLinks: React.FC<FooterLinksProps> = ({ links }) => {
  return (
    <div>
      {links.map((link, index) => (
        <div key={index}>
          {link.to.startsWith("http") ? (
            <a href={link.to} className={styles.LinkA}>
              <div>{link.text}</div>
            </a>
          ) : (
            <RouterLink to={link.to} className={styles.LinkA}>
              <div>{link.text}</div>
            </RouterLink>
          )}
        </div>
      ))}
    </div>
  );
};

const Footer: FC<FooterProps> = () => {
  const { isIPBlocked, userProfile } = useAuth();
  const GooglePlayUrl = (!!isIPBlocked || !!userProfile?.habitsId) ? process.env.REACT_APP_SPARX_GAME_PLAY_STORE : process.env.REACT_APP_SPARX_GAME_PLAY_STORE2;
  const AppStoreUrl = (!!isIPBlocked || !!userProfile?.habitsId) ? process.env.REACT_APP_SPARX_GAME_APP_STORE : process.env.REACT_APP_SPARX_GAME_APP_STORE2;

  return <div className={styles.Footer} data-testid="Footer">
    <section id="footer">
      <div className={styles.SectionView}>
        {/* links */}
        <div>
          <Grid container spacing={{xs: 4, md: 8, lg: 10, xl: 12}} justifyContent='space-between'>
            <Grid item xs={12} md={6} lg={4}>
              <img src={Logo} alt="logo" style={{width: '280px'}} />
            </Grid>
            {footerPanels.map((panel, index) => (
              <Grid item xs={12} md={6} lg={panel.lg} key={index}>
                <div className={styles.FooterTitleText}>{panel.title}</div>
                <FooterLinks links={panel.links}/>
                <br/>
              </Grid>
            ))}
            <Grid item xs={12} md={6} lg={3}>
              <div className={styles.FooterTitleText}>Download the app</div>
              <div style={{paddingTop: "12px"}}>
                <a target="_blank" rel="noopener noreferrer" href={GooglePlayUrl}>
                  <img src={GooglePlay} alt="Google play" style={{paddingRight: "20px"}}/>
                </a>
                <a target="_blank" rel="noopener noreferrer" href={AppStoreUrl}>
                  <img src={AppStore} alt="App store"/>
                </a>
              </div>

              <br/>
              <div className={styles.FooterTitleText}>Social</div>
              <div style={{paddingTop: "12px"}}>
                <a href="https://www.youtube.com/channel/UCYxJ5yEID6wIGcasb2rIpSQ/">
                  <img src={YoutubeLogo} alt="Youtube logo" className={styles.FooterSocialIcon}/>
                </a>
                <a href="https://www.instagram.com/sparx_nz/">
                  <img src={InstagramLogo} alt="Instagram logo" className={styles.FooterSocialIcon}/>
                </a>
                <a href="https://www.facebook.com/soarwithsparx/">
                  <img src={FaceBookLogo} alt="Facebook logo" className={styles.FooterSocialIcon}/>
                </a>
              </div>
            </Grid>
          </Grid>
          <br/><br/>
          <hr style={{strokeWidth: "1px", stroke: "#FFF", opacity: "0.2", marginBottom: "22px"}}/>
          <br/>
        </div>
        {/* logos and terms */}
        <Grid container alignItems="center">
          <Grid item xs={12} xl={7} container alignItems="center" style={{textAlign: "left"}}>
            <img src={NIHILogo} alt="NIHI logo" className={styles.FooterBottomLogo}/>
            <img src={UniServicesLogo} alt="Uniservices logo" className={styles.FooterBottomLogo}/>
            <img src={UoALogo} alt="UOA logo" className={styles.FooterBottomLogo}/>
          </Grid>
          <Grid item xs={12} xl={5} alignItems="center" style={{opacity: "1.0"}}>
            <div className={styles.TermsOfUseLine}>
              <a href="https://www.sparx.org.nz/privacy-policy" className={styles.UnsetA}>Privacy Policy</a>
              <span className={styles.VerticalDivider}>|</span>
              <a href="https://www.sparx.org.nz/terms-conditions" className={styles.UnsetA}>Terms & Conditions</a>
              <span className={styles.TermsOfUseLineHidden}>
                <span className={styles.VerticalDivider}>|</span>Auckland UniServices Ltd 2009-2024 ©
              </span>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
    <section id="nihi-sparx-webflow-chatbotton" className="no-print">
      <a href="https://helpline.homecaremedical.co.nz/Sparx/" target="_blank" rel="noreferrer">
        <img src={ChatIcon} alt="chat" className={styles.ChatIcon} />
        <span className={styles.ChatButton}>Need help? Chat with us</span>
      </a>
    </section>
  </div>;
};

export default Footer;
